module.exports = __webpack_public_path__ + "img/kjjh_detail.8253d841.jpg";